<div class="modal-header">
  <h4 class="modal-title" translate="users.card.addTitle"></h4>

  <button class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form name="itemForm" #rfidForm="ngForm">
    <div class="form-group">
      <input id="typeahead-http" type="text" class="form-control"
        pattern="{{textInputPattern}}"
        [class.is-invalid]="searchFailed"
        [(ngModel)]="rfidCardResult"
        [ngbTypeahead]="searchRfidCards"
        [inputFormatter]="formatter"
        [resultFormatter]="formatter"
        [resultTemplate]="rtRfidCard"
        [ngModelOptions]="{standalone: true}"
        placeholder="{{ 'cards.searchPlaceholder' | translate }}"/>
        @if (searchFailed) {
          <div class="invalid-feedback" translate="users.findCustomer.searchFailed"></div>
        }
      </div>
      @if (alreadyAssigned) {
        <small class="text-danger font-italic" translate="users.card.cardAlreadyAssign"></small>
      }
      @if (selfAssigned) {
        <small class="text-danger font-italic" translate="users.card.selfAssigned"></small>
      }
    </form>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-outline-secondary"
      (click)="activeModal.dismiss()"
      translate="common.cancel">
    </button>
    <button type="button" class="btn btn-primary"
      [disabled]="!(rfidCardResult && rfidCardResult.cardNumber)"
      (click)="addOrUpdateRfidCard()"
      translate="cards.actions.assign">
    </button>
  </div>

  <ng-template #rtRfidCard let-rfidCard="result" let-t="term">
    <ngb-highlight [result]="printFormattedCardIdentifier(rfidCard)" [term]="t"></ngb-highlight>
  </ng-template>
